"use client";
// Une «Mi visita» con el pago conjunto de tours: qué actividades ya están por pagar juntas y cuánto suman.
import { useEffect, useState } from "react";
import { EVENTO_CARRITO, idVisitaDe, leerCarrito, quitarDelCarrito, subtotalLinea, type LineaCarrito } from "@/lib/carrito";

export function usePagoTours() {
  const [lineas, setLineas] = useState<LineaCarrito[]>([]);
  useEffect(() => {
    const leer = () => setLineas(leerCarrito());
    leer();
    window.addEventListener(EVENTO_CARRITO, leer);
    window.addEventListener("storage", leer);
    return () => { window.removeEventListener(EVENTO_CARRITO, leer); window.removeEventListener("storage", leer); };
  }, []);
  const ids = new Set(lineas.map(idVisitaDe));
  const total = lineas.reduce((n, l) => n + subtotalLinea(l), 0);
  /** Al quitar un tour del plan también sale del pago conjunto. */
  const soltar = (idVisita: string) => lineas.filter((l) => idVisitaDe(l) === idVisita).forEach((l) => quitarDelCarrito(l.salidaId));
  return { lineas, ids, total, soltar };
}
